import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function FactoryShowcase() {
  return <section id="factory" className="relative min-h-screen flex items-end md:items-center overflow-hidden bg-[#D4A574]" data-id="element-93">
      {/* Desktop Background Image */}
      <div className="hidden md:block absolute inset-0 z-0" data-id="element-94">
        <img src="https://cdn.magicpatterns.com/uploads/rJy2F1LYHWnwbX2SbVCGSF/Banner_laptop_(1).png" alt="The Best Hair Factory - Premium Vietnamese Hair" className="w-full h-full object-cover object-center" data-id="element-95" />
      </div>

      {/* Mobile Background Image */}
      <div className="md:hidden absolute inset-0 z-0" data-id="element-96">
        <img src="https://cdn.magicpatterns.com/uploads/azU18K6cRVPjR94EqJ5GeR/Mobile_banner.png" alt="The Best Hair Factory - Premium Vietnamese Hair" className="w-full h-full object-cover object-center" data-id="element-97" />
      </div>

      {/* Content Container - Right Corner Below Hero Text */}
      <div className="container max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 pb-12 md:pb-20 pt-32 md:pt-0" data-id="element-98">
        <div className="flex justify-center md:justify-end" data-id="element-99">
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8
        }} className="max-w-xl md:max-w-md lg:max-w-lg text-center md:text-right md:mt-60 lg:mt-72" data-id="element-100">
            {/* Headline */}
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 leading-tight tracking-tight drop-shadow-lg" data-id="element-101">
              100% Vietnamese Human Hair
            </h1>

            {/* Subheadline */}
            <p className="text-base md:text-lg text-white font-medium mb-8 leading-relaxed drop-shadow-md" data-id="element-102">
              Top 1 wholesale hair supplier for global customers with
              factory-direct pricing and reliable worldwide shipping
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 mb-8 justify-center md:justify-end" data-id="element-103">
              <Button size="lg" className="shadow-xl hover:shadow-2xl transition-all" onClick={() => window.open('https://api.whatsapp.com/send/?phone=84869812254&text&type=phone_number&app_absent=0', '_blank')} data-id="element-104">
                Get Price List
              </Button>
              <Button variant="outline" size="lg" className="shadow-lg hover:shadow-xl transition-all bg-white/95 backdrop-blur-sm border-white/50 text-[#4B280B] hover:bg-white font-semibold" onClick={() => document.getElementById('collection')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-105">
                View Collections
              </Button>
            </div>

            {/* Trust Indicators */}
            <div className="grid grid-cols-3 gap-4 pt-6 border-t border-white/30" data-id="element-106">
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.6,
              delay: 0.3
            }} className="text-center" data-id="element-107">
                <div className="text-2xl md:text-3xl font-bold text-white mb-1 drop-shadow-md" data-id="element-108">
                  10+
                </div>
                <div className="text-xs text-white/90 font-medium drop-shadow-sm" data-id="element-109">
                  Years Experience
                </div>
              </motion.div>
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.6,
              delay: 0.4
            }} className="text-center" data-id="element-110">
                <div className="text-2xl md:text-3xl font-bold text-white mb-1 drop-shadow-md" data-id="element-111">
                  50+
                </div>
                <div className="text-xs text-white/90 font-medium drop-shadow-sm" data-id="element-112">
                  Countries Served
                </div>
              </motion.div>
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.6,
              delay: 0.5
            }} className="text-center" data-id="element-113">
                <div className="text-2xl md:text-3xl font-bold text-white mb-1 drop-shadow-md" data-id="element-114">
                  1T
                </div>
                <div className="text-xs text-white/90 font-medium drop-shadow-sm" data-id="element-115">
                  Monthly Capacity
                </div>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}